import { Article } from './article';
import { LeaseAgreementCategory, PropertyTaxCalculationBasis, PropertyTaxCalculationMethod } from './const/enums';
import { Contract } from './contract';
import { PropertyTaxRentalChangeModel } from './property-tax-rental-change';

export enum Responsibility {
  Landlord = 0,
  Tenant = 1,
}

export enum MaintenanceResponsibility {
  Landlord = 0,
  Tenant = 1,
  BorderDrawingList = 2,
}

export enum LandlordVatLiability {
  NotLiable = 0,
  Liable = 1,
  Optional = 2,
}

export class PremisesAgreementConditions {
  constructor() {
    this.maintenanceResponsible = MaintenanceResponsibility.Landlord;
    this.securityResponsible = Responsibility.Landlord;
    this.externalDamageResponsible = Responsibility.Landlord;
    this.propertyTaxPayer = Responsibility.Landlord;
    this.businessVatLiability = false;
    this.landlordVatLiability = LandlordVatLiability.NotLiable;
  }

  maintenanceResponsible: MaintenanceResponsibility;
  securityResponsible: Responsibility;
  externalDamageResponsible: Responsibility;
  propertyTaxPayer: Responsibility;
  businessVatLiability: boolean;
  landlordVatLiability: LandlordVatLiability;
  propertyTaxCalculationBasis: PropertyTaxCalculationBasis;
  propertyTaxPercentage: number;
  propertyTaxCalculationMethod: PropertyTaxCalculationMethod;
  propertyTaxArticleId: string;
  propertyTaxRetroactiveArticleId: string;
}

export class PremisesContract extends Contract {
  constructor() {
    super(LeaseAgreementCategory.Premises);
    this.agreementConditions = new PremisesAgreementConditions();
  }

  public agreementConditions: PremisesAgreementConditions;
  public propertyTaxArticles: Article[];
  public propertyTaxRentalChange: PropertyTaxRentalChangeModel;
}
